import { AbstractModalService } from '@/core/modals/AbstractModalService';
import { ModalOptions } from '@/core/modals/ModalState';
import { AddressViewObject, DeliveryAddressViewObject } from '@/types/apiServerContract';

class CheckoutChangeAddressOverlayService extends AbstractModalService {
    public show(
        deliveryAddresses: DeliveryAddressViewObject[],
        deliveryAddress: AddressViewObject | DeliveryAddressViewObject | null,
        allowedCountryCodes: string[],
        options?: Partial<ModalOptions>
    ) {
        return this.showModal<DeliveryAddressViewObject>({
            component: () => import(
                /* webpackPrefetch: true */
                '@/project/app/client-pages/checkout/addresses/CheckoutChangeAddressOverlay.vue'),
            componentAttrs: {
                deliveryAddresses,
                deliveryAddress,
                allowedCountryCodes
            },
            options: {
                wide: true,
                usePanelWrapper: false,
                closeButtonPosition: 'right-30',
                showCloseButton: true,
                disableUserClose: true,
                closeOnBreakpointChange: false,
                ...options
            }
        });
    }
}

export default new CheckoutChangeAddressOverlayService();
